import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideIonicAngular } from '@ionic/angular/standalone';
import {
  LanguagePreferenceService,
  provideCommoI18n,
  provideCommoSharedDataAccess,
  PushNotificationsFacade,
  ThemePreferenceService,
} from '@sankarah/commo-shared-data-access';
import { provideCommoSharedEnvironment } from '@sankarah/commo-shared-environment';
import { appRoutes } from './app.routes';
import { DismissOverlaysOnNavigateService } from './dismiss-overlays-on-navigate.service';
import { environment } from './environments/environment';
import { PwaUpdateService } from './pwa-update.service';
import { provideCommoSentry } from './sentry';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideIonicAngular({
      mode: 'md',
      animated: false,
      /** ModalController の `componentProps` を Angular `setInput` 経由にし、signal `input()` と整合させる。 */
      useSetInputAPI: true,
      /**
       * PWA / モバイルブラウザの戻るで、先に Popover・Modal などを閉じる。
       * Close Watcher 非対応環境は `DismissOverlaysOnNavigateService` が保険。
       * @see https://ionicframework.com/docs/developing/hardware-back-button
       */
      experimentalCloseWatcher: true,
    }),
    provideCommoSharedEnvironment(environment),
    provideCommoSentry(),
    provideCommoSharedDataAccess({
      supabaseUrl: environment.supabaseUrl,
      supabaseKey: environment.supabaseKey,
    }),
    ...provideCommoI18n(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAppInitializer(() => {
      const languagePreference = inject(LanguagePreferenceService);
      const themePreference = inject(ThemePreferenceService);
      const push = inject(PushNotificationsFacade);
      const pwa = inject(PwaUpdateService);
      const dismissOverlays = inject(DismissOverlaysOnNavigateService);
      themePreference.initFromDevice();
      languagePreference.initFromDevice();
      return languagePreference.syncWithAccount().finally(() => {
        push.startNotificationClickHandling();
        pwa.start();
        dismissOverlays.start();
      });
    }),
  ],
};
